

export const renderGridLabelColumn = (rowData, col, rowIndex) => {
  const { valueField, getLabelClass } = col.colSettings
  // Provide a default format if colSettings is not defined
  const displayVal = rowData?.[col.fieldName]
  // const cssClass = getLabelClass(rowData?.[valueField])
  const cssClass = getLabelClass(displayVal)
  return (
    <span className={cssClass}>{displayVal}</span>
  );
};
